import React, { useEffect, useState } from 'react';
import { DatePicker, Select } from 'antd';
import moment from 'moment';
import locale from 'antd/es/date-picker/locale/bn_BD';
import 'antd/dist/antd.css';
import dayjs from "dayjs";
import { useAuth } from '../../../../context/AuthContext';
import swal from "sweetalert";
import { useNavigate } from 'react-router-dom';
import {
    getCaseCategoriesApi,
    getLawOfficersApi,
    getJusticeNamesApi,
    getRespondentsApi,
    getCaseTypesByCategoryApi,
    getLawOfficerNamesByOfficerApi,
    createHighCourtEntryApi,
} from '../../../../api/master.api';
import { uploadGeneralCaseFileApi } from '../../../../api/uploadFile.api';
const { Option } = Select;

const CaseGeneral = () => {
    const { user } = useAuth();
    const navigate = useNavigate()
    // console.log(user);
    const [formData, setFormData] = useState({
        case_category: '',
        case_type: '',
        case_number: '',
        case_year: '',
        filing_date: '',
        justiceNames: [{ name: '' }],
        relatedOfficers: [{ officer: '', name: '' }],
        plaintiffs: [{ name: '', mobile: '', address: '' }],
        defendants: [{ name: '', mobile: '', address: '' }],
        petitioner_count: '',
        respondents: [{ name: '' }],
        case_description: '',
        case_cost: '',
        court_order_received: '',
        stay_order_des: '',
        documents: [{ name: '', file: '' }],
        hearingDates: [{ lastHearingDate: '', nextHearingDate: '', comment: '' }],
        ha_case_court_name: '',
        ha_case_justice_name: '',
        rule_issue_date: ''
    });
    const [errors, setErrors] = useState({});
    const [courtCategoryOptions, setCourtCategoryOptions] = useState([]);
    const [caseTypeOptions, setCaseTypeOptions] = useState([]);
    const [justiceOptions, setJusticeOptions] = useState([]);
    const [officerOptions, setOfficerOptions] = useState([]);
    const [respondentOptions, setRespondentOptions] = useState([]);


    // Fetch Case Category Data
    useEffect(() => {
        const getCategories = async () => {
            try {
                const res = await getCaseCategoriesApi(1, 100, '');
                const items = res.data?.data?.items ?? [];
                const options = items.map((item) => ({
                    value: item.category_id,
                    label: item.category_name,
                }));
                setCourtCategoryOptions(options);
            } catch (err) {
                console.error(err);
            }
        };

        getCategories();
    }, []);


    useEffect(() => {
        const getCategories = async () => {
            try {
                const res = await getLawOfficersApi(1, 100, '');
                const items = res.data?.data?.items ?? [];
                const options = items.map((item) => ({
                    value: item.law_officer_id,
                    label: item.law_officer_name,
                }));
                setOfficerOptions(options);
            } catch (err) {
                console.error(err);
            }
        };

        getCategories();
    }, []);


    useEffect(() => {
        const getCategories = async () => {
            try {
                const res = await getJusticeNamesApi(1, 100, '');
                const items = res.data?.data?.items ?? [];
                const options = items.map((item) => ({
                    value: item.justice_id,
                    label: item.justice_name,
                }));
                setJusticeOptions(options);
            } catch (err) {
                console.error(err);
            }
        };

        getCategories();
    }, []);


    useEffect(() => {
        const getCategories = async () => {
            try {
                const res = await getRespondentsApi(1, 100, '');
                const items = res.data?.data?.items ?? [];
                const options = items.map((item) => ({
                    value: item.respondent_id,
                    label: item.respondent_name,
                }));
                setRespondentOptions(options);
            } catch (err) {
                console.error(err);
            }
        };

        getCategories();
    }, []);



    useEffect(() => {
        const getCategories = async () => {
            try {
                const res = await getCaseTypesByCategoryApi(formData.case_category);
                const rows = res.data?.data ?? [];
                const options = rows.map((item) => ({
                    value: item.case_type_id,
                    label: item.case_type_name,
                }));
                setCaseTypeOptions(options);
            } catch (err) {
                console.error(err);
            }
        };

        if (formData.case_category) {
            getCategories();
        }
    }, [formData.case_category]);







    const engToBangla = (num) => {
        const banglaDigits = ['০', '১', '২', '৩', '৪', '৫', '৬', '৭', '৮', '৯'];
        return num.toString().split('').map(d => banglaDigits[d]).join('');
    };

    const petitionerCountOptions = Array.from({ length: 1000 }, (_, i) => ({
        value: (i + 1).toString(),
        label: engToBangla(i + 1),
    }));


    const handleInputChange = (field, value) => {
        console.log(field, value);
        setFormData(prev => ({
            ...prev,
            [field]: value
        }));
        setErrors(prev => {
            const next = { ...prev };
            // clear primitive field error on change
            if (next[field]) {
                delete next[field];
            }
            return next;
        });
    };

    const handleDateChange = (field, date) => {
        if (date && moment.isMoment(date) && date.isValid()) {
            handleInputChange(field, date.format('YYYY-MM-DD'));
        } else if (date === null) {
            handleInputChange(field, '');
        } else {
            console.warn('Invalid date selected:', date);
            handleInputChange(field, '');
        }
    };

    const getSafeDateValue = (dateString) => {
        if (!dateString) return null;
        return dayjs(dateString, 'YYYY-MM-DD').isValid() ? dayjs(dateString, 'YYYY-MM-DD') : null;
    };
    const addJustice = () => {
        setFormData(prev => ({
            ...prev,
            justiceNames: [...prev.justiceNames, { name: '' }]
        }));
    };

    const removeJustice = (index) => {
        if (formData.justiceNames.length > 1) {
            setFormData(prev => ({
                ...prev,
                justiceNames: prev.justiceNames.filter((_, i) => i !== index)
            }));
        }
    };

    const updateJustice = (index, value) => {
        const newJustices = [...formData.justiceNames];
        newJustices[index] = { name: value };
        setFormData(prev => ({
            ...prev,
            justiceNames: newJustices
        }));
        setErrors(prev => {
            if (!prev.justiceNames) return prev;
            const nextArr = [...prev.justiceNames];
            nextArr[index] = false;
            return { ...prev, justiceNames: nextArr };
        });
    };

    const addOfficer = () => {
        setFormData(prev => ({
            ...prev,
            relatedOfficers: [...prev.relatedOfficers, { officer: '', name: '' }]
        }));
    };

    const removeOfficer = (index) => {
        if (formData.relatedOfficers.length > 1) {
            setFormData(prev => ({
                ...prev,
                relatedOfficers: prev.relatedOfficers.filter((_, i) => i !== index)
            }));
        }
    };

    const updateOfficer = async (index, field, value) => {
        const newOfficers = [...formData.relatedOfficers];
        newOfficers[index] = { ...newOfficers[index], [field]: value };

        // Officer change হলে API call করো
        if (field === "officer" && value) {
            try {
                const res = await getLawOfficerNamesByOfficerApi(value);
                const rows = res.data?.data ?? [];
                const options = rows.map((item) => ({
                    value: item.officer_name_id,
                    label: item.officer_name,
                }));

                // nameOptions বসিয়ে দাও
                newOfficers[index].nameOptions = options;
                newOfficers[index].name = ""; // নতুন officer select হলে name reset
            } catch (err) {
                console.error(err);
            }
        }

        setFormData(prev => ({
            ...prev,
            relatedOfficers: newOfficers
        }));
        setErrors(prev => {
            if (!prev.relatedOfficers) return prev;
            const nextArr = prev.relatedOfficers.map((e, i) => ({ ...(e || {}), officer: false, name: false }));
            return { ...prev, relatedOfficers: nextArr };
        });
    };


    const addRespondent = () => {
        setFormData(prev => ({
            ...prev,
            respondents: [...prev.respondents, { name: '' }]
        }));
    };

    const removeRespondent = (index) => {
        if (formData.respondents.length > 1) {
            setFormData(prev => ({
                ...prev,
                respondents: prev.respondents.filter((_, i) => i !== index)
            }));
        }
    };

    const updateRespondent = (index, value) => {
        const newRespondents = [...formData.respondents];
        newRespondents[index] = { name: value };
        setFormData(prev => ({
            ...prev,
            respondents: newRespondents
        }));
    };

    // Plaintiff functions
    const addPlaintiff = () => {
        setFormData(prev => ({
            ...prev,
            plaintiffs: [...prev.plaintiffs, { name: '', mobile: '', address: '' }]
        }));
    };


    const removePlaintiff = (index) => {
        if (formData.plaintiffs.length > 1) {
            setFormData(prev => ({
                ...prev,
                plaintiffs: prev.plaintiffs.filter((_, i) => i !== index)
            }));
        }
    };

    const updatePlaintiff = (index, field, value) => {
        const newPlaintiffs = [...formData.plaintiffs];
        newPlaintiffs[index] = { ...newPlaintiffs[index], [field]: value };
        setFormData(prev => ({
            ...prev,
            plaintiffs: newPlaintiffs
        }));
        setErrors(prev => {
            if (!prev.plaintiffs) return prev;
            const nextArr = [...prev.plaintiffs];
            nextArr[index] = { ...nextArr[index], [field]: false };
            return { ...prev, plaintiffs: nextArr };
        });
    };

    // Defendant functions
    const addDefendant = () => {
        setFormData(prev => ({
            ...prev,
            defendants: [...prev.defendants, { name: '', mobile: '', address: '' }]
        }));
    };

    const removeDefendant = (index) => {
        if (formData.defendants.length > 1) {
            setFormData(prev => ({
                ...prev,
                defendants: prev.defendants.filter((_, i) => i !== index)
            }));
        }
    };

    const updateDefendant = (index, field, value) => {
        const newDefendants = [...formData.defendants];
        newDefendants[index] = { ...newDefendants[index], [field]: value };
        setFormData(prev => ({
            ...prev,
            defendants: newDefendants
        }));
        setErrors(prev => {
            if (!prev.defendants) return prev;
            const nextArr = [...prev.defendants];
            nextArr[index] = { ...nextArr[index], [field]: false };
            return { ...prev, defendants: nextArr };
        });
    };

    const addHearingDate = () => {
        console.log(formData);
        setFormData(prev => ({
            ...prev,
            hearingDates: [...prev.hearingDates, { lastHearingDate: '', nextHearingDate: '', comment: '' }]
        }));
    };

    const removeHearingDate = (index) => {
        if (formData.hearingDates.length > 1) {
            setFormData(prev => ({
                ...prev,
                hearingDates: prev.hearingDates.filter((_, i) => i !== index)
            }));
        }
    };

    const updateHearingDate = (index, field, value) => {
        const newHearingDates = [...formData.hearingDates];
        newHearingDates[index] = { ...newHearingDates[index], [field]: value };
        setFormData(prev => ({
            ...prev,
            hearingDates: newHearingDates
        }));
    };

    const addDocument = () => {
        setFormData({
            ...formData,
            documents: [...formData.documents, { name: '', file: '' }]
        });
    };

    const removeDocument = (index) => {
        const updatedDocs = [...formData.documents];
        updatedDocs.splice(index, 1);
        setFormData({ ...formData, documents: updatedDocs });
    };

    const styles = {
        container: {
            maxWidth: '1200px',
            margin: '0 auto',
            backgroundColor: 'white',
            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
            border: '1px solid #e5e7eb'
        },
        header: {
            backgroundColor: '#f3f4f6',
            padding: '12px 16px',
            borderBottom: '1px solid #e5e7eb'
        },
        headerTitle: {
            fontSize: '18px',
            fontWeight: 'bold',
            color: '#1f2937',
            margin: 0
        },
        tabNav: {
            borderBottom: '1px solid #e5e7eb',
            backgroundColor: '#f9fafb',
            display: 'flex',
            overflowX: 'auto'
        },
        tabButton: {
            padding: '12px 16px',
            fontSize: '12px',
            fontWeight: '500',
            borderBottom: '2px solid transparent',
            transition: 'all 0.2s',
            whiteSpace: 'nowrap',
            border: 'none',
            background: 'none',
            cursor: 'pointer'
        },
        activeTabButton: {
            borderBottomColor: '#3b82f6',
            color: '#2563eb',
            backgroundColor: 'white'
        },
        inactiveTabButton: {
            color: '#4b5563'
        },
        warningBox: {
            backgroundColor: '#fef2f2',
            border: '1px solid #fecaca',
            padding: '12px',
            marginBottom: '16px',
            fontSize: '14px',
            color: '#b91c1c'
        },
        formInput: {
            width: '100%',
            padding: '8px',
            border: '1px solid #d1d5db',
            borderRadius: '4px',
            fontSize: '14px'
        },
        datePicker: {
            width: '100%',
            height: '36px'
        },
        searchableSelect: {
            width: '100%',
            height: '36px'
        },
        textarea: {
            width: '100%',
            padding: '8px',
            border: '1px solid #d1d5db',
            borderRadius: '4px',
            fontSize: '14px',
            resize: 'none'
        },
        label: {
            display: 'block',
            fontSize: '14px',
            fontWeight: '500',
            marginBottom: '4px'
        },
        removeButton: {
            width: '32px',
            height: '32px',
            backgroundColor: '#ef4444',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            transition: 'background-color 0.2s'
        },
        addButton: {
            marginTop: '8px',
            padding: '4px 12px',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            fontSize: '14px',
            cursor: 'pointer',
            transition: 'background-color 0.2s'
        },
        helpIcon: {
            width: '16px',
            height: '16px',
            backgroundColor: '#3b82f6',
            color: 'white',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '12px',
            marginLeft: '8px'
        },
        warningIcon: {
            width: '16px',
            height: '16px',
            backgroundColor: '#ef4444',
            color: 'white',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '12px',
            marginLeft: '8px'
        },
        uploadSection: {
            backgroundColor: '#ecfeff',
            border: '1px solid #67e8f9',
            padding: '12px',
            marginBottom: '16px'
        },
        uploadHeader: {
            fontSize: '14px',
            fontWeight: '500',
            color: '#155e75',
            marginBottom: '12px'
        },
        submitButton: {
            padding: '8px 24px',
            backgroundColor: '#0d9488',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            fontWeight: '500',
            cursor: 'pointer',
            transition: 'background-color 0.2s'
        },
        greenAddButton: {
            width: '24px',
            height: '24px',
            backgroundColor: '#16a34a',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            transition: 'background-color 0.2s'
        },
        browseButton: {
            padding: '8px 12px',
            backgroundColor: '#6b7280',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            fontSize: '14px',
            cursor: 'pointer',
            transition: 'background-color 0.2s'
        },
        errorText: {
            color: '#b91c1c',
            fontSize: '12px',
            marginTop: '4px'
        }
    };
    console.log(formData);
    const handleSubmit = async (e) => {
        if (e && e.preventDefault) e.preventDefault();
        const nextErrors = {};

        if (!formData.case_category) nextErrors.case_category = true;
        if (!formData.case_type) nextErrors.case_type = true;
        if (!formData.case_number) nextErrors.case_number = true;
        if (!formData.case_year) nextErrors.case_year = true;
        if (!formData.filing_date) nextErrors.filing_date = true;
        if (!formData.rule_issue_date) nextErrors.rule_issue_date = true;


        // Related officer: require at least one row with both fields
        const officerValidity = formData.relatedOfficers.map(r => ({
            officer: !!r.officer,
            name: !!r.name
        }));
        const hasValidOfficerRow = officerValidity.some(v => v.officer && v.name);
        if (!hasValidOfficerRow) {
            nextErrors.relatedOfficers = formData.relatedOfficers.map(r => ({
                officer: !r.officer,
                name: !r.name
            }));
        }

        // Plaintiff validation: require at least one plaintiff with name
        const plaintiffValidity = formData.plaintiffs.map(p => !!p.name);
        const hasAtLeastOnePlaintiff = plaintiffValidity.some(Boolean);
        if (!hasAtLeastOnePlaintiff) {
            nextErrors.plaintiffs = formData.plaintiffs.map(p => ({ name: !p.name, mobile: false, address: false }));
        }
        if (!formData.court_order_received) nextErrors.court_order_received = true;

        setErrors(nextErrors);

        const hasPrimitiveErrors = Object.keys(nextErrors).some(
            key => !Array.isArray(nextErrors[key]) && nextErrors[key]
        );

        const hasOfficerErrors = Array.isArray(nextErrors.relatedOfficers) && nextErrors.relatedOfficers.some(v => v.officer || v.name);
        const hasPlaintiffErrors = Array.isArray(nextErrors.plaintiffs) && nextErrors.plaintiffs.some(v => v.name);

        const hasAnyError = hasPrimitiveErrors || hasOfficerErrors || hasPlaintiffErrors;
        if (hasAnyError) return alert('Please fill out all required fields.');


        try {
            // 🔹 Upload all document files and get URLs
            const uploadedDocs = await Promise.all(
                formData.documents.map(async (doc) => {
                    if (doc.file) {
                        const res = await uploadGeneralCaseFileApi(doc.file);
                        const fileUrl = res.data?.data?.fileUrl;
                        return { ...doc, url: fileUrl, file: '' };
                    }
                    return doc;
                })
            );

            const finalData = {
                ...formData,
                created_by: user?.id,
                documents: uploadedDocs,
                court_type_id: 1
            };

            const res = await createHighCourtEntryApi(finalData);
            if (res.data?.success) {
                swal({
                    title: "Thank you",
                    text: "Successfully Added",
                    icon: "success",
                    button: "Ok",
                });
                navigate(`/report/high-court/all-case`);
                setFormData({
                    case_category: '',
                    case_type: '',
                    case_number: '',
                    case_year: '',
                    filing_date: '',
                    justiceNames: [{ name: '' }],
                    relatedOfficers: [{ officer: '', name: '' }],
                    plaintiffs: [{ name: '', mobile: '', address: '' }],
                    defendants: [{ name: '', mobile: '', address: '' }],
                    petitioner_count: '',
                    respondents: [{ name: '' }],
                    case_description: '',
                    case_cost: '',
                    court_order_received: '',
                    stay_order_des: '',
                    documents: [{ name: '', file: '' }],
                    hearingDates: [{ lastHearingDate: '', nextHearingDate: '', comment: '' }],
                    ha_case_court_name: '',
                    ha_case_justice_name: '',
                    rule_issue_date: ''
                });
            }
        } catch (err) {
            console.error("Submit failed:", err);
            alert("Something went wrong while submitting.");
        }
    };


    return (
        <div style={{ backgroundColor: 'white', textAlign: 'left' }}>
            {/* First Row - Three columns */}
            <div className="row mb-3">
                <div className="col-md-4">
                    <label style={styles.label}>
                        মামলার ক্যাটেগরি *
                    </label>
                    <Select
                        style={styles.searchableSelect}
                        placeholder="--- নির্বাচন করুন ---"
                        value={formData.case_category || undefined}
                        onChange={(value) => handleInputChange('case_category', value)}
                        status={errors.case_category ? 'error' : ''}
                        showSearch
                        filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        allowClear
                    >
                        {courtCategoryOptions.map(option => (
                            <Option key={option.value} value={option.value}>
                                {option.label}
                            </Option>
                        ))}
                    </Select>
                    {errors.case_category && (
                        <div style={styles.errorText}>এই ঘরটি অবশ্যই পূরণ করতে হবে</div>
                    )}
                </div>

                <div className="col-md-4">
                    <label style={styles.label}>
                        মামলার শ্রেণী/কেস-টাইপ *
                    </label>
                    <Select
                        style={styles.searchableSelect}
                        placeholder="--- নির্বাচন করুন ---"
                        value={formData.case_type || undefined}
                        onChange={(value) => handleInputChange('case_type', value)}
                        status={errors.case_type ? 'error' : ''}
                        showSearch
                        filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        allowClear
                    >
                        {caseTypeOptions.map(option => (
                            <Option key={option.value} value={option.value}>
                                {option.label}
                            </Option>
                        ))}
                    </Select>
                    {errors.case_type && (
                        <div style={styles.errorText}>এই ঘরটি অবশ্যই পূরণ করতে হবে</div>
                    )}
                </div>

                <div className="col-md-4">
                    <label style={styles.label}>
                        মামলার নং *
                    </label>
                    <input
                        type="text"
                        placeholder="(Type digits in English)"
                        style={{ ...styles.formInput, borderColor: errors.case_number ? '#ef4444' : '#d1d5db' }}
                        value={formData.case_number}
                        onChange={(e) => handleInputChange('case_number', e.target.value)}
                    />
                    {errors.case_number && (<div style={styles.errorText}>এই ঘরটি অবশ্যই পূরণ করতে হবে</div>)}
                </div>
            </div>

            {/* Second Row - Two columns */}
            <div className="row mb-3">
                <div className="col-md-4">
                    <label style={styles.label}>
                        বছর *
                    </label>
                    <DatePicker
                        picker="year"
                        placeholder="--- নির্বাচন করুন ---"
                        style={{ width: "100%" }}
                        value={formData.case_year ? dayjs(formData.case_year, "YYYY") : null}
                        onChange={(date, dateString) =>
                            handleInputChange("case_year", dateString) // returns only year string like "2025"
                        }
                        status={errors.case_year ? 'error' : ''}
                    />
                    {errors.case_year && (
                        <div style={styles.errorText}>এই ঘরটি অবশ্যই পূরণ করতে হবে</div>
                    )}
                </div>

                <div className="col-md-4">
                    <label style={styles.label}>
                        মামলা দায়েরের তারিখ *
                    </label>
                    <DatePicker
                        style={styles.datePicker}
                        placeholder="দিন/মাস/বছর"
                        value={getSafeDateValue(formData.filing_date)}
                        onChange={(date) => handleDateChange('filing_date', date)}
                        format="DD/MM/YYYY"
                        locale={locale}
                        allowClear={true}
                        inputReadOnly={false}
                        showToday={true}
                        showTime={false}
                        status={errors.filing_date || (formData.filing_date && !getSafeDateValue(formData.filing_date)) ? 'error' : ''}
                        onBlur={(e) => {
                            const inputValue = e.target.value;
                            if (inputValue) {
                                const parsedDate = moment(inputValue, 'DD/MM/YYYY');
                                if (parsedDate.isValid()) {
                                    handleDateChange('filing_date', parsedDate);
                                }
                            }
                        }}
                    />
                    {errors.filing_date && (<div style={styles.errorText}>এই ঘরটি অবশ্যই পূরণ করতে হবে</div>)}
                </div>
                <div className="col-md-4">
                    <label style={styles.label}>
                        আদালতের নাম
                    </label>
                    <input
                        type="text"
                        style={styles.formInput}
                        value={formData.ha_case_court_name}
                        onChange={(e) => handleInputChange('ha_case_court_name', e.target.value)}
                    />
                </div>
                <div className="col-md-8 mt-3">
                    <label style={styles.label}>
                        Justice Name
                    </label>
                    <input
                        type="text"
                        style={styles.formInput}
                        value={formData.ha_case_justice_name}
                        onChange={(e) => handleInputChange('ha_case_justice_name', e.target.value)}
                    />
                </div>
                <div className="col-md-4 mt-3">
                    <label style={styles.label}>
                        রুল ইস্যুর তারিখ *
                    </label>
                    <DatePicker
                        style={styles.datePicker}
                        placeholder="দিন/মাস/বছর"
                        value={getSafeDateValue(formData.rule_issue_date)}
                        onChange={(date) => handleDateChange('rule_issue_date', date)}
                        format="DD/MM/YYYY"
                        locale={locale}
                        allowClear={true}
                        inputReadOnly={false}
                        showToday={true}
                        showTime={false}
                        status={errors.rule_issue_date || (formData.rule_issue_date && !getSafeDateValue(formData.rule_issue_date)) ? 'error' : ''}
                        onBlur={(e) => {
                            const inputValue = e.target.value;
                            if (inputValue) {
                                const parsedDate = moment(inputValue, 'DD/MM/YYYY');
                                if (parsedDate.isValid()) {
                                    handleDateChange('rule_issue_date', parsedDate);
                                }
                            }
                        }}
                    />
                    {errors.rule_issue_date && (<div style={styles.errorText}>এই ঘরটি অবশ্যই পূরণ করতে হবে</div>)}
                </div>




                {/* Justice Names Section - Multiple */}
                {/* <div className="col-md-4 border p-2">
                    <label style={{ ...styles.label, display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                        আদালতের নাম (Justice Name)*
                        <span style={styles.helpIcon}>?</span>
                        <button
                            type="button"
                            className='bg-success text-white ms-2'
                            onClick={addJustice}
                            style={styles.addButton}
                        >
                            <i className="fa fa-plus" style={{ fontSize: '14px' }}></i>
                        </button>
                    </label>
                    {formData.justiceNames.map((justice, index) => (
                        <div key={index} style={{ display: 'flex', gap: '8px', marginBottom: '8px' }}>
                            <Select
                                style={{ ...styles.searchableSelect, flex: '1' }}
                                placeholder="--- নির্বাচন করুন ---"
                                value={justice.name || undefined}
                                onChange={(value) => updateJustice(index, value)}
                                status={Array.isArray(errors.justiceNames) && errors.justiceNames[index] ? 'error' : ''}
                                showSearch
                                filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                                allowClear
                            >
                                {justiceOptions.map(option => (
                                    <Option key={option.value} value={option.value}>
                                        {option.label}
                                    </Option>
                                ))}
                            </Select>
                            <button
                                type="button"
                                onClick={() => removeJustice(index)}
                                style={styles.removeButton}
                                onMouseOver={(e) => e.target.style.backgroundColor = '#dc2626'}
                                onMouseOut={(e) => e.target.style.backgroundColor = '#ef4444'}
                            >
                                <i className="fas fa-minus" style={{ fontSize: '14px' }}></i>
                            </button>
                        </div>
                    ))}
                    {Array.isArray(errors.justiceNames) && errors.justiceNames.every(Boolean) && (
                        <div style={styles.errorText}>কমপক্ষে একটি আদালতের নাম নির্বাচন করুন</div>
                    )}
                </div> */}
            </div>

            {/* Related Officers Section - Multiple */}
            <div style={{ marginBottom: '16px' }} className="border p-2">
                <div className="row mb-2">
                    <div className="col-md-6">
                        <label style={{ ...styles.label, display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                            সংশ্লিষ্ট আইন কর্মকর্তা *
                        </label>
                        {Array.isArray(errors.relatedOfficers) && errors.relatedOfficers.some(e => e.officer) && (
                            <div style={styles.errorText}>কমপক্ষে একজন কর্মকর্তাকে নির্বাচন করুন</div>
                        )}
                    </div>
                    <div className="col-md-6">
                        <label style={{ ...styles.label, display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                            সংশ্লিষ্ট আইন কর্মকর্তার নাম *
                            <span style={styles.helpIcon}>?</span>
                        </label>
                        {Array.isArray(errors.relatedOfficers) && errors.relatedOfficers.some(e => e.name) && (
                            <div style={styles.errorText}>কমপক্ষে একটি নাম নির্বাচন করুন</div>
                        )}
                    </div>
                </div>

                {formData.relatedOfficers.map((officer, index) => (
                    <div key={index} className="row mb-2">
                        <div className="col-md-6">
                            <Select
                                style={styles.searchableSelect}
                                placeholder="--- নির্বাচন করুন ---"
                                value={officer.officer || undefined}
                                onChange={(value) => updateOfficer(index, 'officer', value)}
                                status={Array.isArray(errors.relatedOfficers) && errors.relatedOfficers[index] && errors.relatedOfficers[index].officer ? 'error' : ''}
                                showSearch
                                filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                                allowClear
                            >
                                {officerOptions.map(option => (
                                    <Option key={option.value} value={option.value}>
                                        {option.label}
                                    </Option>
                                ))}
                            </Select>
                        </div>

                        <div className="col-md-6">
                            <div style={{ display: 'flex', gap: '8px' }}>
                                <Select
                                    style={{ ...styles.searchableSelect, flex: '1' }}
                                    placeholder="--- নির্বাচন করুন ---"
                                    value={officer.name || undefined}
                                    onChange={(value) => updateOfficer(index, 'name', value)}
                                    status={Array.isArray(errors.relatedOfficers) && errors.relatedOfficers[index] && errors.relatedOfficers[index].name ? 'error' : ''}
                                    showSearch
                                    filterOption={(input, option) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                    allowClear
                                >
                                    {(officer.nameOptions || []).map(option => (
                                        <Option key={option.value} value={option.value}>
                                            {option.label}
                                        </Option>
                                    ))}
                                </Select>
                                <button
                                    type="button"
                                    onClick={() => removeOfficer(index)}
                                    style={styles.removeButton}
                                    onMouseOver={(e) => e.target.style.backgroundColor = '#dc2626'}
                                    onMouseOut={(e) => e.target.style.backgroundColor = '#ef4444'}
                                >
                                    <i className="fas fa-minus" style={{ fontSize: '14px' }}></i>
                                </button>
                            </div>
                        </div>
                    </div>
                ))}
                <button
                    type="button"
                    onClick={addOfficer}
                    className="bg-success"
                    style={styles.addButton}
                    onMouseOver={(e) => e.target.style.backgroundColor = '#2563eb'}
                    onMouseOut={(e) => e.target.style.backgroundColor = '#3b82f6'}
                >
                    আরও যোগ করুন
                </button>
            </div>

            {/* Plaintiff Section - Multiple entries */}
            <div style={{ marginBottom: '16px' }} className="border p-2">
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px' }}>
                    <h4 style={{ fontSize: '16px', fontWeight: '500', color: '#1f2937', margin: 0 }}>
                        বাদী (Petitioner) *
                    </h4>
                    <button
                        type="button"
                        onClick={addPlaintiff}
                        className='bg-success text-white'
                        style={styles.addButton}
                        onMouseOver={(e) => e.target.style.backgroundColor = '#2563eb'}
                        onMouseOut={(e) => e.target.style.backgroundColor = '#3b82f6'}
                    >
                        আরও যোগ করুন
                    </button>
                </div>

                {formData.plaintiffs.map((plaintiff, index) => (
                    <div key={index} style={{ marginBottom: '16px', padding: '12px', backgroundColor: 'white', border: '1px solid #e9ecef', borderRadius: '4px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '12px' }}>
                            <span style={{ fontSize: '14px', fontWeight: '500', color: '#495057' }}>
                                বাদী #{index + 1}
                            </span>
                            {formData.plaintiffs.length > 1 && (
                                <button
                                    type="button"
                                    onClick={() => removePlaintiff(index)}
                                    style={styles.removeButton}
                                    className='ms-3'
                                    onMouseOver={(e) => e.target.style.backgroundColor = '#dc2626'}
                                    onMouseOut={(e) => e.target.style.backgroundColor = '#ef4444'}
                                >
                                    <i className="fas fa-minus" style={{ fontSize: '14px' }}></i>
                                </button>
                            )}
                        </div>

                        <div className="row">
                            <div className="col-md-4">
                                <label style={styles.label}>
                                    বাদীর নাম *
                                </label>
                                <textarea
                                    style={{
                                        ...styles.textarea,
                                        height: '40px',
                                        borderColor: Array.isArray(errors.plaintiffs) && errors.plaintiffs[index] && errors.plaintiffs[index].name ? '#ef4444' : '#d1d5db'
                                    }}
                                    value={plaintiff.name}
                                    onChange={(e) => updatePlaintiff(index, 'name', e.target.value)}
                                />
                                {Array.isArray(errors.plaintiffs) && errors.plaintiffs[index] && errors.plaintiffs[index].name && (
                                    <div style={styles.errorText}>এই ঘরটি অবশ্যই পূরণ করতে হবে</div>
                                )}
                            </div>
                            <div className="col-md-4">
                                <label style={styles.label}>
                                    বাদীর মোবাইল নম্বর
                                </label>
                                <textarea
                                    style={{ ...styles.textarea, height: '40px' }}
                                    value={plaintiff.mobile}
                                    onChange={(e) => updatePlaintiff(index, 'mobile', e.target.value)}
                                />
                            </div>
                            <div className="col-md-4">
                                <label style={styles.label}>
                                    বাদীর ঠিকানা
                                </label>
                                <textarea
                                    style={{ ...styles.textarea, height: '40px' }}
                                    value={plaintiff.address}
                                    onChange={(e) => updatePlaintiff(index, 'address', e.target.value)}
                                />
                            </div>
                        </div>
                    </div>
                ))}
                {Array.isArray(errors.plaintiffs) && errors.plaintiffs.some(p => p.name) && (
                    <div style={styles.errorText}>কমপক্ষে একজন বাদীর নাম পূরণ করুন</div>
                )}
            </div>

            {/* Defendant Section - Multiple entries */}
            <div style={{ marginBottom: '16px' }} className="border p-2">
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px' }}>
                    <h4 style={{ fontSize: '16px', fontWeight: '500', color: '#1f2937', margin: 0 }}>
                        বিবাদী (Respondent)
                    </h4>
                    <button
                        type="button"
                        onClick={addDefendant}
                        className='bg-success text-white'
                        style={styles.addButton}
                        onMouseOver={(e) => e.target.style.backgroundColor = '#2563eb'}
                        onMouseOut={(e) => e.target.style.backgroundColor = '#3b82f6'}
                    >
                        আরও যোগ করুন
                    </button>
                </div>

                {formData.defendants.map((defendant, index) => (
                    <div key={index} style={{ marginBottom: '16px', padding: '12px', backgroundColor: 'white', border: '1px solid #e9ecef', borderRadius: '4px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '12px' }}>
                            <span style={{ fontSize: '14px', fontWeight: '500', color: '#495057' }}>
                                বিবাদী #{index + 1}
                            </span>
                            {formData.defendants.length > 1 && (
                                <button
                                    type="button"
                                    onClick={() => removeDefendant(index)}
                                    style={styles.removeButton}
                                    className='ms-3'
                                    onMouseOver={(e) => e.target.style.backgroundColor = '#dc2626'}
                                    onMouseOut={(e) => e.target.style.backgroundColor = '#ef4444'}
                                >
                                    <i className="fas fa-minus" style={{ fontSize: '14px' }}></i>
                                </button>
                            )}
                        </div>

                        <div className="row">
                            <div className="col-md-4">
                                <label style={styles.label}>
                                    বিবাদীর নাম
                                </label>
                                <textarea
                                    style={{ ...styles.textarea, height: '40px' }}
                                    value={defendant.name}
                                    onChange={(e) => updateDefendant(index, 'name', e.target.value)}
                                />
                            </div>
                            <div className="col-md-4">
                                <label style={styles.label}>
                                    বিবাদীর মোবাইল নম্বর
                                </label>
                                <textarea
                                    style={{ ...styles.textarea, height: '40px' }}
                                    value={defendant.mobile}
                                    onChange={(e) => updateDefendant(index, 'mobile', e.target.value)}
                                />
                            </div>
                            <div className="col-md-4">
                                <label style={styles.label}>
                                    বিবাদীর ঠিকানা
                                </label>
                                <textarea
                                    style={{ ...styles.textarea, height: '40px' }}
                                    value={defendant.address}
                                    onChange={(e) => updateDefendant(index, 'address', e.target.value)}
                                />
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* Plaintiff Count and Respondent Section - Two columns */}
            <div className="row mb-3">
                <div className="col-md-6">
                    <label style={styles.label}>
                        মোট বাদীর সংখ্যা
                    </label>
                    <Select
                        style={styles.searchableSelect}
                        placeholder="মোট বাদীর সংখ্যা নির্বাচন করুন"
                        value={formData.petitioner_count || undefined}
                        onChange={(value) => handleInputChange('petitioner_count', value)}
                        showSearch
                        filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        allowClear
                    >
                        {petitionerCountOptions.map(option => (
                            <Option key={option.value} value={option.value}>
                                {option.label}
                            </Option>
                        ))}
                    </Select>
                </div>

                {/* <div className="col-md-6 border p-2">
                    <label style={{ ...styles.label, display: 'flex', alignItems: 'center' }}>
                        রেসপন্ডেন্ট সংখ্যা
                        <span style={styles.warningIcon}>!</span>
                    </label>
                    {formData.respondents.map((respondent, index) => (
                        <div key={index} style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                            <span style={{ width: '24px', fontSize: '14px', textAlign: 'center' }}>{index + 1}</span>
                            <Select
                                style={{ ...styles.searchableSelect, flex: '1' }}
                                placeholder="--- নির্বাচন করুন ---"
                                value={respondent.name || undefined}
                                onChange={(value) => updateRespondent(index, value)}
                                showSearch
                                filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                                allowClear
                            >
                                {respondentOptions.map(option => (
                                    <Option key={option.value} value={option.value}>
                                        {option.label}
                                    </Option>
                                ))}
                            </Select>
                            <button
                                type="button"
                                onClick={() => removeRespondent(index)}
                                style={styles.removeButton}
                                onMouseOver={(e) => e.target.style.backgroundColor = '#dc2626'}
                                onMouseOut={(e) => e.target.style.backgroundColor = '#ef4444'}
                            >
                                <i className="fas fa-minus" style={{ fontSize: '14px' }}></i>
                            </button>
                        </div>
                    ))}
                    <button
                        type="button"
                        onClick={addRespondent}
                        className='bg-success text-white'
                        style={styles.addButton}
                        onMouseOver={(e) => e.target.style.backgroundColor = '#2563eb'}
                        onMouseOut={(e) => e.target.style.backgroundColor = '#3b82f6'}
                    >
                        আরও যোগ করুন
                    </button>
                </div> */}
            </div>

            {/* Case Description */}
            <div style={{ marginBottom: '16px' }}>
                <label style={styles.label}>
                    বিষয়বস্তু(সংক্ষিপ্ত)
                </label>
                <textarea
                    style={{ ...styles.textarea, height: '128px' }}
                    value={formData.case_description}
                    onChange={(e) => handleInputChange('case_description', e.target.value)}
                />
            </div>

            {/* Hearing Dates Section - Multiple */}
            <div style={{ backgroundColor: '#f8f9fa', padding: '16px', marginBottom: '16px', border: '1px solid #e9ecef', borderRadius: '4px' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px' }}>
                    <p style={{ fontSize: '14px', color: '#495057', fontWeight: '500', margin: 0 }}>
                        <span style={{ color: '#dc3545', background: "#fef2f2", padding: '8px' }}>শুনানি তারিখঃ</span>
                    </p>
                    <button
                        type="button"
                        onClick={addHearingDate}
                        className='bg-success text-white'
                        style={styles.addButton}
                        onMouseOver={(e) => e.target.style.backgroundColor = '#2563eb'}
                        onMouseOut={(e) => e.target.style.backgroundColor = '#3b82f6'}
                    >
                        আরও যোগ করুন
                    </button>
                </div>

                {formData.hearingDates.map((hearingDate, index) => (
                    <div key={index} style={{ marginBottom: '16px', padding: '12px', backgroundColor: 'white', border: '1px solid #e9ecef', borderRadius: '4px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '12px' }}>
                            <span style={{ fontSize: '14px', fontWeight: '500', color: '#495057' }}>
                                শুনানি তারিখ #{index + 1}
                            </span>
                            {formData.hearingDates.length > 1 && (
                                <button
                                    type="button"
                                    onClick={() => removeHearingDate(index)}
                                    style={styles.removeButton}
                                    className='ms-3'
                                    onMouseOver={(e) => e.target.style.backgroundColor = '#dc2626'}
                                    onMouseOut={(e) => e.target.style.backgroundColor = '#ef4444'}
                                >
                                    <i className="fas fa-minus" style={{ fontSize: '14px' }}></i>
                                </button>
                            )}
                        </div>

                        <div className="row">
                            <div className="col-md-4">
                                <label style={styles.label}>
                                    সর্বশেষ শুনানির তারিখঃ
                                </label>
                                <DatePicker
                                    style={styles.datePicker}
                                    placeholder="দিন/মাস/বছর"
                                    value={getSafeDateValue(hearingDate.lastHearingDate)}
                                    onChange={(date) => {
                                        if (date && moment.isMoment(date) && date.isValid()) {
                                            updateHearingDate(index, 'lastHearingDate', date.format('YYYY-MM-DD'));
                                        } else if (date === null) {
                                            updateHearingDate(index, 'lastHearingDate', '');
                                        }
                                    }}
                                    format="DD/MM/YYYY"
                                    locale={locale}
                                    allowClear={true}
                                    inputReadOnly={false}
                                    showToday={true}
                                    showTime={false}
                                    onBlur={(e) => {
                                        const inputValue = e.target.value;
                                        if (inputValue) {
                                            const parsedDate = moment(inputValue, 'DD/MM/YYYY');
                                            if (parsedDate.isValid()) {
                                                updateHearingDate(index, 'lastHearingDate', parsedDate.format('YYYY-MM-DD'));
                                            }
                                        }
                                    }}
                                />
                            </div>

                            <div className="col-md-4">
                                <label style={styles.label}>
                                    পরবর্তী শুনানির তারিখঃ
                                </label>
                                <DatePicker
                                    style={styles.datePicker}
                                    placeholder="দিন/মাস/বছর"
                                    value={getSafeDateValue(hearingDate.nextHearingDate)}
                                    onChange={(date) => {
                                        if (date && moment.isMoment(date) && date.isValid()) {
                                            updateHearingDate(index, 'nextHearingDate', date.format('YYYY-MM-DD'));
                                        } else if (date === null) {
                                            updateHearingDate(index, 'nextHearingDate', '');
                                        }
                                    }}
                                    format="DD/MM/YYYY"
                                    locale={locale}
                                    allowClear={true}
                                    inputReadOnly={false}
                                    showToday={true}
                                    showTime={false}
                                    onBlur={(e) => {
                                        const inputValue = e.target.value;
                                        if (inputValue) {
                                            const parsedDate = moment(inputValue, 'DD/MM/YYYY');
                                            if (parsedDate.isValid()) {
                                                updateHearingDate(index, 'nextHearingDate', parsedDate.format('YYYY-MM-DD'));
                                            }
                                        }
                                    }}
                                />
                            </div>

                            <div className="col-md-4">
                                <label style={styles.label}>
                                    মন্তব্য (সংক্ষিপ্ত):
                                </label>
                                <textarea
                                    style={{ ...styles.textarea, height: '80px' }}
                                    value={hearingDate.comment || ''}
                                    onChange={(e) => updateHearingDate(index, 'comment', e.target.value)}
                                />
                            </div>
                        </div>
                    </div>
                ))}
            </div>




            {/* Additional Info Section */}
            <div style={{ marginBottom: '16px' }}>
                <p style={{ fontSize: '14px', marginBottom: '8px' }}>
                    মামলা সংশ্লিষ্ট অর্থের পরিমান(যদি আর্থিক সংশ্লেষ থাকে বা সরকারি অর্থ ব্যয়/প্রদানের বিষয় থাকে অথবা মামলাভুক্ত সম্পত্তির সম্ভাব্য মূল্য ইত্যাদি)
                </p>
                <input
                    type="text"
                    style={styles.formInput}
                    value={formData.case_cost}
                    onChange={(e) => handleInputChange('case_cost', e.target.value)}
                />
            </div>

            {/* Radio Button Section */}
            <div style={{ marginBottom: '16px' }}>
                <p style={{ fontSize: '14px', fontWeight: '500', marginBottom: '8px' }}>
                    স্থগিতাদেশ/স্থিতাবস্থা/অন্তর্বর্তীকালীন আদেশ প্রদান করা হয়েছে কিনা?*
                </p>
                <div style={{ display: 'flex', gap: '24px' }}>
                    <label style={{ display: 'flex', alignItems: 'center', fontSize: '14px' }}>
                        <input
                            type="checkbox"
                            checked={formData.court_order_received === "yes"}
                            onChange={() => handleInputChange('court_order_received', formData.court_order_received === "yes" ? "" : "yes")}
                            style={{ marginRight: '8px' }}
                        />
                        হ্যাঁ
                    </label>
                    <label style={{ display: 'flex', alignItems: 'center', fontSize: '14px' }}>
                        <input
                            type="checkbox"
                            checked={formData.court_order_received === "no"}
                            onChange={() => handleInputChange('court_order_received', formData.court_order_received === "no" ? "" : "no")}
                            style={{ marginRight: '8px' }}
                        />
                        না
                    </label>
                    <label style={{ display: 'flex', alignItems: 'center', fontSize: '14px' }}>
                        <input
                            type="checkbox"
                            checked={formData.court_order_received === "not_applicable"}
                            onChange={() => handleInputChange('court_order_received', formData.court_order_received === "not_applicable" ? "" : "not_applicable")}
                            style={{ marginRight: '8px' }}
                        />
                        প্রযোজ্য নয়
                    </label>
                </div>
                {errors.court_order_received && (
                    <div style={styles.errorText}>একটি অপশন নির্বাচন করুন</div>
                )}

                {formData.court_order_received === 'yes' && (
                    <div style={{ marginBottom: '16px' }}>
                        <label style={styles.label}>
                            স্থগিতাদেশের সংক্ষিপ্ত বিবরণ
                        </label>
                        <textarea
                            style={{ ...styles.textarea, height: '128px' }}
                            value={formData.stay_order_des}
                            onChange={(e) => handleInputChange('stay_order_des', e.target.value)}
                        />
                    </div>
                )}
            </div>

            {/* File Upload Section - Multiple Documents */}
            <div style={styles.uploadSection}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '12px' }}>
                    <h3 style={styles.uploadHeader}>
                        রুলের কপি সংযুক্ত করুন (PDF, সর্বোচ্চ সাইজ : 5MB)
                    </h3>
                    <button
                        type="button"
                        onClick={addDocument}
                        style={styles.greenAddButton}
                        onMouseOver={(e) => e.target.style.backgroundColor = '#15803d'}
                        onMouseOut={(e) => e.target.style.backgroundColor = '#16a34a'}
                    >
                        <i className="fas fa-plus" style={{ fontSize: '12px' }}></i>
                    </button>
                </div>

                {formData.documents.map((doc, index) => (
                    <div key={index} style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                        <input
                            type="text"
                            value={doc.name}
                            onChange={(e) => {
                                const updatedDocs = [...formData.documents];
                                updatedDocs[index].name = e.target.value;
                                setFormData({ ...formData, documents: updatedDocs });
                            }}
                            style={{ ...styles.formInput, flex: '1', width: "30%" }}
                        />

                        <input
                            type="file"
                            accept=".pdf,.doc,.docx"
                            onChange={(e) => {
                                const file = e.target.files[0];
                                const updatedDocs = [...formData.documents];
                                updatedDocs[index].file = file;
                                setFormData({ ...formData, documents: updatedDocs });
                            }}
                            style={{ flex: '1', width: "40%", backgroundColor: '#f3f4f6', border: '1px solid #cbd5e1', borderRadius: '4px', padding: '8px' }}
                        />

                        <button
                            type="button"
                            onClick={() => removeDocument(index)}
                            style={{
                                width: '24px',
                                height: '24px',
                                backgroundColor: '#ef4444',
                                color: 'white',
                                border: 'none',
                                borderRadius: '4px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: 'pointer',
                                transition: 'background-color 0.2s'
                            }}
                            onMouseOver={(e) => e.target.style.backgroundColor = '#dc2626'}
                            onMouseOut={(e) => e.target.style.backgroundColor = '#ef4444'}
                        >
                            <i className="fas fa-minus" style={{ fontSize: '12px' }}></i>
                        </button>
                    </div>
                ))}
            </div>

            {/* Submit Button */}
            <div className="text-center">
                <button
                    type="submit"
                    style={styles.submitButton}
                    onMouseOver={(e) => e.target.style.backgroundColor = '#0f766e'}
                    onMouseOut={(e) => e.target.style.backgroundColor = '#0d9488'}
                    onClick={handleSubmit}
                >
                    সংরক্ষণ
                </button>
            </div>
        </div>
    );
};

export default CaseGeneral;